module.exports = __webpack_public_path__ + "images/1-en.b12e3dd74d0562adf7bdc6df4920b799.jpg";